module.exports = __webpack_public_path__ + "static/media/Konec_prazdnin.cab46499.jpg";